import { render, staticRenderFns } from "./StartPageTemplate.vue?vue&type=template&id=3b095c6a&scoped=true"
import script from "./StartPageTemplate.vue?vue&type=script&lang=js"
export * from "./StartPageTemplate.vue?vue&type=script&lang=js"
import style0 from "./StartPageTemplate.vue?vue&type=style&index=0&id=3b095c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b095c6a",
  null
  
)

export default component.exports